import { encryptAES } from '../encryption/CryptoService';

const IS_ENCRYPTION_ENABLED = process.env.REACT_APP_IS_ENCRYPTION === 'true';

// Sub-helper 1: Handles POST payload transformations cleanly
const handlePostBody = (body) => {
    if (body === undefined || body === null) return undefined;

    const plainText = typeof body === 'string' ? body : JSON.stringify(body);

    return IS_ENCRYPTION_ENABLED
        ? { data: encryptAES(plainText) }
        : { data: plainText };
};

// Sub-helper 2: Handles GET/DELETE parameter stringification/encryption
const handleQueryParams = (params) => {
    if (!params) return undefined;

    const alreadyWrapped = Object.keys(params).length === 1 && 'data' in params;
    const valueToProcess = alreadyWrapped ? String(params.data) : JSON.stringify(params);

    return IS_ENCRYPTION_ENABLED
        ? { data: encryptAES(valueToProcess) }
        : { data: valueToProcess };
};

// Main Orchestrator: Complexity drops from 19 to below 5!
export const encryptRequest = (args) => {
    const method = (args.method || 'GET').toUpperCase();

    if (args.body instanceof FormData) return args;

    if (method === 'POST') {
        const transformedBody = handlePostBody(args.body);
        return transformedBody !== undefined ? { ...args, body: transformedBody } : args;
    }

    if (method === 'GET' || method === 'DELETE') {
        const transformedParams = handleQueryParams(args.params);
        return transformedParams !== undefined ? { ...args, params: transformedParams } : args;
    }

    return args;
};